import React from 'react';
import CommonButton from '@nhl/nhl-react-ui/lib/Forms/Button';

import { buttonProps } from './propTypes';

import './styles.scss';

const Button = ({ label, style = {}, href, onClick, disabled, className = '' }) => (
    <div className="common-button">
        <CommonButton
            className={ className }
            text={ label }
            style={ style }
            href={ href }
            onClick={ onClick }
            disabled={disabled} />
    </div>
);

Button.propTypes = buttonProps;

export default Button;
